// ConfirmDialog — MD3 Dialog с кнопками Cancel и Confirm.
// Используется для подтверждения деструктивных действий (soft-delete и т.п.).
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import type { ReactNode } from 'react';

interface ConfirmDialogProps {
  /** Флаг открытия диалога. */
  open: boolean;
  /** Заголовок диалога. */
  title: string;
  /** Текст сообщения внутри диалога. */
  message: ReactNode;
  /** Текст кнопки подтверждения (по умолчанию "Подтвердить"). */
  confirmLabel?: string;
  /** Текст кнопки отмены (по умолчанию "Отмена"). */
  cancelLabel?: string;
  /** Цвет кнопки подтверждения (по умолчанию primary). */
  confirmColor?: 'primary' | 'error' | 'secondary';
  /** Обработчик подтверждения. */
  onConfirm: () => void;
  /** Обработчик отмены. */
  onCancel: () => void;
}

/** Универсальный диалог подтверждения. */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  confirmColor = 'primary',
  onConfirm,
  onCancel,
}: ConfirmDialogProps): JSX.Element {
  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description">
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} color="inherit">
          {cancelLabel}
        </Button>
        <Button onClick={onConfirm} variant="contained" color={confirmColor} autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
